import React from 'react';

export default class Image extends React.Component {
    render () {
        return <img src={ this.props.src } className={ 'img-responsive' + ( this.props.className ? ' ' + this.props.className : '') }/>
    }
};